// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MuiTableCell-body{
  padding : 10px 4px !important;
}

/* .MuiTableCell-body:last-child {
  text-align: right;
} */
`, "",{"version":3,"sources":["webpack://./src/pages/RiskRegister/RiskConfiguration/tableStyles.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;AAC/B;;AAEA;;GAEG","sourcesContent":[".MuiTableCell-body{\n  padding : 10px 4px !important;\n}\n\n/* .MuiTableCell-body:last-child {\n  text-align: right;\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
